import { render, staticRenderFns } from "./StudyNowButton.vue?vue&type=template&id=b61f469a"
import script from "./StudyNowButton.vue?vue&type=script&lang=js"
export * from "./StudyNowButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports